// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailActiveRequestFragmentDoc } from '../../routes/bids/BidPackageDetailPage.generated';
import { DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PlanBasedBidsTable_ReadyPlanOptionFragmentDoc, PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc, PlanBasedBidsTable_ReadyPlanFragmentDoc } from '../../routes/bids/components/PlanBasedBidsTable.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractPlanPricing_RevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type BidContractPlanPricing_RevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, name: string, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string }
          | { __typename?: 'ItemTemplateItem', id: string }
          | { __typename?: 'TakeoffLineItem', id: string }
          | { __typename?: 'TakeoffLineItemVersion', id: string }
         | null | undefined }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } } };

export type BidContractPlanPricing_RevisionFragment = { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, name: string, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string }
        | { __typename?: 'ItemTemplateItem', id: string }
        | { __typename?: 'TakeoffLineItem', id: string }
        | { __typename?: 'TakeoffLineItemVersion', id: string }
       | null | undefined }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } };

export type BidContractPlanPricing_ScopeLinesQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
  filter: Types.BpvScopeLinesFilter;
}>;


export type BidContractPlanPricing_ScopeLinesQuery = { __typename?: 'Query', bidPackageVersionScopeLines: Array<{ __typename?: 'BidPackageScopeLine', takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string, useQuantity: boolean }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } } }> };

export type BidContractPlanPricing_ReadyPlanOptionsQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
}>;


export type BidContractPlanPricing_ReadyPlanOptionsQuery = { __typename?: 'Query', readyPlan: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> } };

export type BidContractPlanPricingTradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string }
      | { __typename?: 'ItemTemplateItem', id: string }
      | { __typename?: 'TakeoffLineItem', id: string }
      | { __typename?: 'TakeoffLineItemVersion', id: string }
     | null | undefined }> };

export const BidContractPlanPricingTradeLineItemFragmentDoc = gql`
    fragment BidContractPlanPricingTradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  productOffering {
    id
  }
  options {
    id
  }
  lineItems {
    id
    totalCostInCents
    itemTemplateItem {
      id
    }
  }
}
    `;
export const BidContractPlanPricing_RevisionFragmentDoc = gql`
    fragment BidContractPlanPricing_Revision on BidContractRevision {
  id
  bidContract {
    id
    isInternalEstimate
    name
    type {
      code
    }
    tradePartner {
      id
      name
    }
    bidRequest {
      ...BidPackageDetailActiveRequest
    }
  }
  tradeLineItems {
    ...BidContractPlanPricingTradeLineItem
  }
  bidPackageVersion {
    id
    readyPlanAggregateVersions {
      ...DisplayNamed
      readyPlan {
        ...PlanBasedBidsTable_ReadyPlan
      }
    }
  }
  canEdit {
    allowed
  }
}
    ${BidPackageDetailActiveRequestFragmentDoc}
${BidContractPlanPricingTradeLineItemFragmentDoc}
${DisplayNamedFragmentDoc}
${PlanBasedBidsTable_ReadyPlanFragmentDoc}`;
export const BidContractPlanPricing_RevisionDocument = gql`
    query BidContractPlanPricing_Revision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    ...BidContractPlanPricing_Revision
  }
}
    ${BidContractPlanPricing_RevisionFragmentDoc}`;

/**
 * __useBidContractPlanPricing_RevisionQuery__
 *
 * To run a query within a React component, call `useBidContractPlanPricing_RevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractPlanPricing_RevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractPlanPricing_RevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useBidContractPlanPricing_RevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables> & ({ variables: BidContractPlanPricing_RevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
      }
export function useBidContractPlanPricing_RevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
        }
// @ts-ignore
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>;
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_RevisionQuery | undefined, BidContractPlanPricing_RevisionQueryVariables>;
export function useBidContractPlanPricing_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>(BidContractPlanPricing_RevisionDocument, options);
        }
export type BidContractPlanPricing_RevisionQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionQuery>;
export type BidContractPlanPricing_RevisionLazyQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionLazyQuery>;
export type BidContractPlanPricing_RevisionSuspenseQueryHookResult = ReturnType<typeof useBidContractPlanPricing_RevisionSuspenseQuery>;
export type BidContractPlanPricing_RevisionQueryResult = ApolloReactCommon.QueryResult<BidContractPlanPricing_RevisionQuery, BidContractPlanPricing_RevisionQueryVariables>;
export const BidContractPlanPricing_ScopeLinesDocument = gql`
    query BidContractPlanPricing_ScopeLines($bidPackageVersionId: ID!, $filter: BPVScopeLinesFilter!) {
  bidPackageVersionScopeLines(id: $bidPackageVersionId, filter: $filter) {
    takeoffLineItemVersion {
      ...PlanBasedBidsTable_TakeoffLineItemVersion
    }
  }
}
    ${PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc}`;

/**
 * __useBidContractPlanPricing_ScopeLinesQuery__
 *
 * To run a query within a React component, call `useBidContractPlanPricing_ScopeLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractPlanPricing_ScopeLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractPlanPricing_ScopeLinesQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidContractPlanPricing_ScopeLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables> & ({ variables: BidContractPlanPricing_ScopeLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
      }
export function useBidContractPlanPricing_ScopeLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
        }
// @ts-ignore
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>;
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ScopeLinesQuery | undefined, BidContractPlanPricing_ScopeLinesQueryVariables>;
export function useBidContractPlanPricing_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>(BidContractPlanPricing_ScopeLinesDocument, options);
        }
export type BidContractPlanPricing_ScopeLinesQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesQuery>;
export type BidContractPlanPricing_ScopeLinesLazyQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesLazyQuery>;
export type BidContractPlanPricing_ScopeLinesSuspenseQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ScopeLinesSuspenseQuery>;
export type BidContractPlanPricing_ScopeLinesQueryResult = ApolloReactCommon.QueryResult<BidContractPlanPricing_ScopeLinesQuery, BidContractPlanPricing_ScopeLinesQueryVariables>;
export const BidContractPlanPricing_ReadyPlanOptionsDocument = gql`
    query BidContractPlanPricing_ReadyPlanOptions($readyPlanId: ID!) {
  readyPlan(id: $readyPlanId) {
    id
    options {
      ...PlanBasedBidsTable_ReadyPlanOption
    }
  }
}
    ${PlanBasedBidsTable_ReadyPlanOptionFragmentDoc}`;

/**
 * __useBidContractPlanPricing_ReadyPlanOptionsQuery__
 *
 * To run a query within a React component, call `useBidContractPlanPricing_ReadyPlanOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractPlanPricing_ReadyPlanOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractPlanPricing_ReadyPlanOptionsQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *   },
 * });
 */
export function useBidContractPlanPricing_ReadyPlanOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables> & ({ variables: BidContractPlanPricing_ReadyPlanOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>(BidContractPlanPricing_ReadyPlanOptionsDocument, options);
      }
export function useBidContractPlanPricing_ReadyPlanOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>(BidContractPlanPricing_ReadyPlanOptionsDocument, options);
        }
// @ts-ignore
export function useBidContractPlanPricing_ReadyPlanOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>;
export function useBidContractPlanPricing_ReadyPlanOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractPlanPricing_ReadyPlanOptionsQuery | undefined, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>;
export function useBidContractPlanPricing_ReadyPlanOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>(BidContractPlanPricing_ReadyPlanOptionsDocument, options);
        }
export type BidContractPlanPricing_ReadyPlanOptionsQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ReadyPlanOptionsQuery>;
export type BidContractPlanPricing_ReadyPlanOptionsLazyQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ReadyPlanOptionsLazyQuery>;
export type BidContractPlanPricing_ReadyPlanOptionsSuspenseQueryHookResult = ReturnType<typeof useBidContractPlanPricing_ReadyPlanOptionsSuspenseQuery>;
export type BidContractPlanPricing_ReadyPlanOptionsQueryResult = ApolloReactCommon.QueryResult<BidContractPlanPricing_ReadyPlanOptionsQuery, BidContractPlanPricing_ReadyPlanOptionsQueryVariables>;